<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">CHISS Payment</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <div style="display: none;" v-if="transaction.txn_number && !currentsoa.txn_number">
                <div :id="`chiss-print`">
                    <img src="/images/tc.png" width="200" class="rounded mx-auto d-block" />

                    <h6 style="margin-top: 50px;">Please pay the amount due below online or by presenting this payment slip to the City Treasury Office.</h6>

                    <div class="alert">
                        <h3>{{ transaction.service_code }} ({{ transaction.txn_number }})</h3>
                        <h4>{{ transaction.description }}</h4>
                    </div>

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="text-center">
                                    Fee Type
                                </th>
                                <th class="text-center">
                                    Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(feeindex, i) in Object.keys(transaction.fees)">
                                <tr
                                    :key="uniqueid(`feeindex-container-print-${i}_`)"
                                >
                                    <td>
                                        <strong>{{ feeindex }}</strong>
                                    </td>
                                    <td>
                                        &#8369;{{ transaction.fees[feeindex] }}
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <td style="text-align: right;">
                                    <strong>Total:</strong>
                                </td>
                                <td>
                                    <strong>&#8369;{{ transaction.total }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <v-col
                cols="12"
                offset-lg="3"
                offset-md="2"
                lg="6"
                md="8"
                v-if="transaction.txn_number && !currentsoa.txn_number"
            >
                <v-card
                    elevation="6"
                >
                    <v-card-text>
                        <v-card-title>
                            {{ transaction.service_code }} ({{ transaction.txn_number }})
                        </v-card-title>
                        <v-card-subtitle>
                            <p class="mx-0 px-0 my-0 py-0">
                                {{ transaction.description }}
                            </p>
                        </v-card-subtitle>
                    </v-card-text>

                    <v-card-text>
                        <v-expansion-panels accordion>
                            <v-expansion-panel >
                                <v-expansion-panel-header disable-icon-rotate color="blue darken-3" class="white--text"><template v-slot:actions><v-icon class="white--text">mdi-receipt</v-icon></template>Breakdown of Fees</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-for="(feeindex, i) in Object.keys(transaction.fees)">
                                            <v-col
                                                cols="8"
                                                :key="uniqueid(`feename-${i}_`)"
                                            >
                                                {{ feeindex }}
                                            </v-col>
                                            <v-col
                                                cols="4"
                                                :key="uniqueid(`feevalue-${i}_`)"
                                            >
                                                &#8369;{{ transaction.fees[feeindex] }}
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-row
                            dense
                            style="border-top: 2px double #000;"
                            class="mx-1 px-5 mt-2"
                        >
                            <v-col
                                cols="8"
                                class="text-right"
                            >
                                <h3>Total:</h3>
                            </v-col>
                            <v-col
                                cols="4"
                            >
                                <h3>&#8369;{{ transaction.total }}</h3>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            text
                            color="green darken-2"
                            @click="OfflinePayment(transaction)"
                        >
                            Offline Payment
                        </v-btn>

                        <v-btn
                            text
                            color="red darken-2"
                            @click="AskOLPassword(transaction)"
                        >
                            Online Payment
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col  
                cols="12"
                md="8"
                offset-md="2"
                lg="6"
                offset-lg="3"
                v-else-if="currentsoa.txn_number"
            >
                <template v-if="prepaymentstep == 1">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <v-select
                                :items="paymentoptions"
                                item-text="text"
                                item-value="value"
                                label="Issuing Bank Type"
                                v-model="prepayment.paymentoption"
                            ></v-select>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                @click="ProceedToNext"
                            >
                                Proceed<v-icon class="ml-2">mdi-arrow-right</v-icon>
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else-if="prepaymentstep == 2">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <p>
                                Issuing Bank Type: <strong>{{ paymentoptions.filter(x => x.value.toString() == prepayment.paymentoption.toString())[0].text }}</strong>
                            </p>

                            <v-select
                                :items="debitcredit"
                                item-text="text"
                                item-value="value"
                                label="Card Type"
                                v-model="prepayment.debitcredit"
                            ></v-select>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                @click="ProceedToNext"
                            >
                                Proceed<v-icon class="ml-2">mdi-arrow-right</v-icon>
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else-if="prepaymentstep == 3">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <p>
                                Issuing Bank Type: <strong>{{ paymentoptions.filter(x => x.value.toString() == prepayment.paymentoption.toString())[0].text }}</strong>
                            </p>
                            <p>
                                Card Type: <strong>{{ prepayment.debitcredit }}</strong>
                            </p>
                            <v-alert
                                type="error"
                            >
                                For debit card holders, is your card enabled for online transaction?
                            </v-alert>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                @click="ProceedToNext"
                            >
                                Yes
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                No, I will confirm it to my Bank
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else-if="prepaymentstep == 4">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <p>
                                Issuing Bank Type: <strong>{{ paymentoptions.filter(x => x.value.toString() == prepayment.paymentoption.toString())[0].text }}</strong>
                            </p>

                            <template v-if="prepayment.api.toString() == 'Nationlink'">
                                <p v-if="prepayment.paymentoption && prepayment.paymentoption.toString() != 'Fortune Pay'">
                                    Card Type: <strong>{{ prepayment.debitcredit }}</strong>
                                </p>
                                <v-divider></v-divider>
                            </template>
                            <p class="mt-4">
                                Amount: <strong>&#8369;{{ transaction.total }}</strong>
                            </p>
                            <template v-if="prepayment.api.toString() == 'Nationlink'">
                                <p>
                                    Convenience Fee: <strong>&#8369;{{ ComputeConvenienceFee() }}</strong>
                                </p>
                                <p>
                                    Total Amount: <strong>&#8369;{{ AmountToPay() }}</strong>
                                </p>
                            </template>

                            <template v-if="prepayment.api.toString() == 'Unionbank'">
                                <p class="text-h6">Convenience Fee</p>
                                <p>Unionbank UBOnline: <strong>&#8369;10</strong></p>
                                <p>Unionbank Instapay: <strong>&#8369;15</strong></p>
                                <p>Unionbank PCHC Paygate: <strong>&#8369;25</strong></p>
                            </template>
                        </v-card-text>

                        <v-card-subtitle>
                            <v-divider></v-divider>

                            <template>
                                <v-checkbox
                                    v-model="prepayment.agreement.conveniencefee"
                                    label="Do you agree to pay the convenience fee stated above?"
                                ></v-checkbox>
                            </template>

                            <template>
                                <v-checkbox
                                    v-model="prepayment.agreement.amounttobepaid"
                                    label="Do you agree to pay the total amount stated above?"
                                ></v-checkbox>
                            </template>
                        </v-card-subtitle>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                :disabled="!prepayment.agreement.conveniencefee || !prepayment.agreement.amounttobepaid"
                                @click="ProceedToNext"
                            >
                                Proceed to Payment<v-icon class="ml-2">mdi-arrow-right</v-icon>
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-col>
        </v-row>

        <v-dialog
            v-model="olpaymentpassmodal"
            scrollable
            max-width="550"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-lock mr-2"></i>Online Payment is Currently on Test Mode</v-card-title>

                <v-card-text>
                    <v-row>   
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="olpaymentpass"
                                label="Enter Test Mode Password"
                                outlined
                                type="password"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn 
                        text
                        dark
                        @click="VerifyPassword"
                    >Verify Password
                    </v-btn>

                    <v-btn 
                        text
                        dark
                        @click="olpaymentpassmodal = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog
            v-model="redirectionmessage"
            scrollable
            max-width="550"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-alert-outline mr-2"></i>Redirection Message</v-card-title>

                <v-card-text>
                    <v-row>   
                        <v-col
                            cols="12"
                        >
                            <p class="mb-2">Your security is important to us.</p>
                            <p class="mb-6">To proceed to your transaction, you will now be redirected to an online payment facility.</p>
                            <p class="mb-2">Ang inyong seguridad ay mahalaga sa amin.</p>
                            <p>Upang tumuloy sa inyong transaksyon, ididirekta po kayo sa isang online payment facility.</p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn 
                        text
                        dark
                        @click="RedirectToPaymentFacility"
                    >Proceed</v-btn>

                    <v-btn 
                        text
                        dark
                        @click="redirectionmessage = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import numeral from "numeral"
import { State, interpret } from "xstate"
import { toggleMachine } from "../../states/toggle"

export default {
    props: [ 'GenerateUB_Cipher', 'randHex', 'UpdateTransactionUB', 'CheckIfLoggedInInternal' ],
    name: 'chisspayment',
    metaInfo: {
        title: 'Digital Tuguegarao - CHISS Payment',
    },
    data() {
        return {
            redirectionmessage: false,
            olpaymentpassmodal: false,
            olpaymentpass: '',
            olpaymentsoa: {},
            overlay: false,
            paymentoptions: [
                // temporary disabled 2022-06-03
                // {
                //     text: 'Nationlink (Local and International Debit and Credit Cards)',
                //     value: 'National',
                // },
                // end
                // {
                //     text: 'International',
                //     value: 'International',
                // },
                {
                    // text: 'Unionbank',
                    text: 'Unionbank (Unionbank accounts, Instapay, PCHC Paygate)',
                    value: 'Unionbank',
                },
                // {
                //     text: 'Fortune Pay (Coming Soon)',
                //     value: 'Fortune Pay',
                //     disabled: true,
                // },
            ],
            debitcredit: [
                {
                    text: 'Debit',
                    value: 'Debit'
                },
                {
                    text: 'Credit',
                    value: 'Credit',
                },
            ],
            prepayment: {
                nameofissuingbank: '',
                paymentoption: 'National',
                debitcredit: 'Debit',
                agreement: {
                    conveniencefee: false,
                    amounttobepaid: false,
                },
                bankcharges: 0,
                nationlinkcharges: 0,
                api: 'Unionbank',
            },
            conveniencefee: 0,
            prepaymentstep: 1,
            currentsoa: {},
            toggleService: interpret(toggleMachine),
            current: toggleMachine.initialState,
            context: toggleMachine.context,
            citizen: {},
            txnnumber: '',
            transaction: {},
        }
    },
    methods: {
        Numeral(num = 0) {
            return numeral(parseFloat(num)).format('0,0.00')
        },
        AmountToPay() {
            const amount = parseFloat(this.transaction.total.replace(/[^.\d]/g, ''))
            const cf = this.ConvenienceFee(amount)

            return this.Numeral(amount + cf)
        },
        ComputeConvenienceFee() {
            const amount = parseFloat(this.transaction.total.replace(/[^.\d]/g, ''))
            return this.Numeral(this.ConvenienceFee(amount))
        },
        NationlinkCF(total) {
            let cf = 50

            if(total > 2500 && total <= 7500) {
                cf = 75
            } else if(total > 7500 && total <= 15000) {
                cf = 100
            } else if(total > 15000 && total <= 30000) {
                cf = 150
            } else if(total > 30000 && total <= 50000) {
                cf = 290
            } else if(total > 50000 && total <= 80000) {
                cf = 460
            } else if(total > 80000 && total <= 120000) {
                cf = 650
            } else if(total > 120000 && total <= 175000) {
                cf = 915
            } else if(total > 175000 && total <= 210000) {
                cf = 1100
            } else if(total > 210000 && total <= 400000) {
                cf = 2100
            } else if(total > 400000) {
                cf = 3000
            }

            return cf
        },
        ConvenienceFee(total = 0) {
            let cffee = 0

            if(this.prepayment.paymentoption && this.prepayment.paymentoption.toString() == 'Fortune Pay'){
                return cffee
            }

            switch(this.prepayment.paymentoption.toString()) {
                case 'National':
                    if(this.prepayment.debitcredit.toString() == 'Debit'){
                        // 2% for debit
                        this.prepayment.bankcharges = total * 0.02
                    } else{
                        // 4% for credit
                        this.prepayment.bankcharges = total * 0.04
                    }
                    break;
                case 'International':
                    if(this.prepayment.debitcredit.toString() == 'Debit'){
                        // 2% for debit
                        this.prepayment.bankcharges = total * 0.02
                    } else{
                        // 4% for credit
                        this.prepayment.bankcharges = total * 0.04
                    }
                    break;
                case 'Fortune Pay':
                    // cffee = (total * 0.035) + 70
                    this.prepayment.bankcharges = total * 0.035
                    break;
            }
            
            this.prepayment.nationlinkcharges = this.NationlinkCF(total)
            // const cffee = (total * 0.035) + 70
            cffee = this.prepayment.bankcharges + this.prepayment.nationlinkcharges

            this.conveniencefee = cffee

            return cffee
        },
        ResetPayment() {
            this.currentsoa = {}

            this.prepayment = {
                nameofissuingbank: '',
                paymentoption: 'National',
                debitcredit: 'Debit',
                agreement: {
                    conveniencefee: false,
                    amounttobepaid: false,
                },
                bankcharges: 0,
                nationlinkcharges: 0,
                api: 'Nationlink',
            }

            this.prepaymentstep = 1

            this.fetch()
        },
        RedirectToPaymentFacility() {
            if(this.prepayment.agreement.conveniencefee && this.prepayment.agreement.amounttobepaid){
                this.ProceedToPayment(this.currentsoa)
            }
        },
        ProceedToNext() {
            switch(parseInt(this.prepaymentstep)) {
                case 1:
                    switch(this.prepayment.paymentoption.toString()) {
                        case 'National': case 'International': 
                            this.prepaymentstep = 2
                            break;
                        case 'Fortune Pay':
                            this.prepaymentstep = 4
                            break;
                        case 'Unionbank':
                            this.prepaymentstep = 4
                            this.prepayment.api = 'Unionbank'
                            this.prepayment.agreement.conveniencefee = false
                            break;
                    }
                    break;
                case 2:
                    if(this.prepayment.debitcredit.toString() == 'Debit') {
                        this.prepaymentstep = 3
                    } else{
                        this.prepaymentstep = 4
                    }
                    break;
                case 3:
                    this.prepaymentstep = 4
                    break;
                case 4:
                    if(this.prepayment.agreement.conveniencefee && this.prepayment.agreement.amounttobepaid){
                        // this.ProceedToPayment(this.currentsoa)
                        // alert(111111)
                        // this.redirectionmessage = true

                        if(this.prepayment.api.toString() == 'Nationlink') {
                            this.ProceedToPayment(this.currentsoa)
                        } else if(this.prepayment.api.toString() == 'Unionbank') {
                            this.redirectionmessage = true
                        }
                    }
                    break;
            }
        },
        Round2Epsilon(num) {
            return Math.round((num + Number.EPSILON) * 100) / 100
        },
        PrePayment() {
            this.currentsoa = this.transaction

            this.prepayment = {
                // old
                // nameofissuingbank: '',
                // paymentoption: 'National',
                // new
                nameofissuingbank: this.paymentoptions.length == 1 ? this.paymentoptions[0].text : '',
                paymentoption: this.paymentoptions.length == 1 ? this.paymentoptions[0].value : 'National',
                debitcredit: 'Debit',
                agreement: {
                    conveniencefee: false,
                    amounttobepaid: false,
                },
                bankcharges: 0,
                nationlinkcharges: 0,
                api: this.paymentoptions.length == 1 ? this.paymentoptions[0].value : 'Nationlink',
            }

            // this.prepaymentstep = 4
            this.prepaymentstep = 1

            // added
            if(this.paymentoptions.length == 1) {
                this.ProceedToNext()
            }
        },
        ProceedToPayment() {
            this.overlay = true

            // console.log(this.transaction)

            axios({
                method: 'post',
                url: `${this.domain}/op_proceed_to_payment`,
                data: {
                    division: 'CHISS',
                    citizenid: this.context.citizen._id.toString(),
                    amount: this.transaction.total,
                    linkid: this.transaction.txn_number,
                    paymentslip: this.transaction.txn_number,
                    subtype: this.transaction.office_code,
                    items: JSON.stringify(this.transaction.fees),
                    quarter: 4,
                    prepayment: JSON.stringify(this.prepayment),
                    others: JSON.stringify({
                        service_code: this.transaction.service_code.toString(),
                        description: this.transaction.description.toString(),
                    })
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        const requestd = this.$jwt.decode(response.data.newid, this.jwtsecret)
                        let ublink = ''

                        switch(this.prepayment.api.toString()) {
                            case 'Nationlink':
                                if(requestd.newid && requestd.newid.toString().length > 0){
                                    this.$router.push({
                                        name: 'payment',
                                        params: {
                                            requestid: requestd.newid.toString(),
                                        }
                                    }).catch(() => {})
                                }
                                break;
                            case 'Unionbank':
                                ublink = this.GenerateUB_Cipher({
                                    Amt: this.transaction.total,
                                    // Redir: `${this.localdomain}chisspayment/${this.txnnumber}`,
                                    Redir: `${this.localdomain}payments/eor/${requestd.newid.toString()}`,
                                    TransactionId: requestd.newid.toString(),
                                    TransactionType: this.transaction.service_code.replace(/[^\w\d]/g, '').substring(0, 50),
                                    // TransactionType: this.transaction.office_code.replace(/[^\w\d]/g, '').substring(0, 50),
                                    // TransactionType: 'Miscellaneous',
                                    // TransactionType: 'Alpha',
                                    Department: 'CHISS',
                                    // Department: 'Assessors',
                                })

                                // window.location = ublink.url.toString()
                                this.UpdateTransactionUB({
                                    id: requestd.newid.toString(),
                                    data: ublink.data,
                                }, () => {
                                    window.location = ublink.url.toString()
                                })
                                break;
                        }

                        // const ublink = this.GenerateUB_Cipher({
                        //     Amt: this.transaction.total,
                        //     Redir: `${this.localdomain}chisspayment/${this.txnnumber}`,
                        //     TransactionId: requestd.newid.toString(),
                        //     TransactionType: this.transaction.office_code,
                        //     Department: 'CHISS',
                        // })

                        // window.location = ublink.toString()
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: response.data.message.toString()
                        })
                    }
                })
                .catch(() => {
                    this.overlay = false

                    this.$emit('snackbar', {
                        variant: 'red darken-2',
                        message: 'Something went wrong.. check again later..'
                    })
                })
        },

        OfflinePayment(tr) {
            axios({
                method: 'post',
                url: `${this.domain}/CHISSOfflinePayment`,
                data: {
                    uid: this.citizen._id.toString(),
                    txnnumber: this.txnnumber.toString(),
                    document: tr.service_code.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        if(response.data.transactions.status.toString() == 'Success'){
                            this.$htmlToPaper(`chiss-print`, null, () => {
                                this.$router.push({
                                    name: 'listofalltransactions'
                                }).catch(() => {})
                            })
                        } else{
                            this.$emit('snackbar', {
                                variant: 'red darken-2',
                                message: 'Something went wrong.. Check this page later...'
                            })
                        }
                    }
                })
        },
        uniqueid(prefix) {
            return _.uniqueId(prefix)
        },
        fetch() {
            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/GetCHISSTransaction`,
                data: {
                    uid: this.citizen._id.toString(),
                    txnnumber: this.txnnumber.toString(),
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        const transactions = this.$jwt.decode(response.data.transactions, this.jwtsecret)

                        const e = JSON.parse(transactions.transactions)

                        if(e && e instanceof Array && e.length > 0){
                            this.transaction = e[0]

                            // console.log(this.transaction)
                        }
                    }
                })
        },
        AskOLPassword(soa) {
            if((this.sysconfig && this.sysconfig.paymenttestmode && this.sysconfig.paymenttestmode == true) || !this.sysconfig){
                this.olpaymentsoa = soa
                this.olpaymentpass = ''
                this.olpaymentpassmodal = true
            } else{
                this.olpaymentpassmodal = false
                // this.PrePayment(soa)
                this.transaction = soa
                this.PrePayment()
                this.olpaymentsoa = {}
            }
        },
        VerifyPassword() {
            if(this.olpaymentpass.toString() == this.onlinepaymentpass.toString()){
                this.olpaymentpassmodal = false
                this.transaction = this.olpaymentsoa
                // this.PrePayment(this.olpaymentsoa)
                this.PrePayment()
                this.olpaymentsoa = {}
            } else{
                alert('Incorrect Module Password')
            }
        },
        SystemConfig() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_sys_config`,
                data: {
                    uid: this.context.citizen._id.toString(),
                }
            })
                .then(response => {
                    const config = this.$jwt.decode(response.data.config, this.jwtsecret)
                    this.sysconfig = config.config
                })
        },
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        this.toggleService.send({
            type: 'CITIZEN',
            citizen: this.citizen
        })

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        if(this.$route.params.txn_number && this.$route.params.txn_number.toString().length > 0){
            this.txnnumber = this.$route.params.txn_number.toString()

            this.fetch()
        } else{
            this.$router.push({
                name: 'listofalltransactions'
            }).catch(()=>{})
        }

        this.SystemConfig()
    },
    created() {
        const stateDefinition = JSON.parse(localStorage.getItem('app-xstate')) || toggleMachine.initialState
        stateDefinition.context.paymentrequest = {}
        const previousState = State.create(stateDefinition)
        const resolvedState = toggleMachine.resolveState(previousState)

        this.toggleService
            .onTransition(state => {
                this.current = state
                this.context = state.context

                localStorage.setItem('app-xstate', JSON.stringify(state))
            })
            .start(resolvedState)
    },
    beforeDestroy() {

    }
}
</script>